module.exports = __webpack_public_path__ + "static/img/a063.d39c62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a063.jpg
// module id = FHxr
// module chunks = 0